import React from 'react'
import { campaignBudgetLabels } from '@revbox/localization'
import { getShortMonthName } from '@revbox/helpers-fe'
import { useCookiesContext } from '../../../../../contexts/CookiesContext'
import { Button, Col, Form, OverlayTrigger, Modal, Row, Badge, Tooltip, Alert, Placeholder, Spinner } from 'react-bootstrap'

export default function CampaignBudget({ show, handleCloseBottom, campaign, publisher, days_diff, onChangeMonthlyBudget, onSaveBudget }) {
    const { getLanguageAbbr } = useCookiesContext()
    const languageAbbr = getLanguageAbbr()
    const multilang = campaignBudgetLabels[languageAbbr]

    return (
        <Modal id="CampaignBudget" show={show} onHide={handleCloseBottom} size="lg" centered>
            <Modal.Header closeButton className="card-one pb-2">
                <Modal.Title className="w-100">
                    {/* center text in div*/}
                    <div className="d-flex justify-content-center align-items-center">
                        {campaign?.name} - {multilang?.title}
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="card-one pt-3">
                <Row className="mb-3">
                    <Col xl="12">
                        <Form
                            noValidate
                            onSubmit={e => {
                                e.preventDefault()
                                e.stopPropagation()
                                handleCloseBottom()
                                onSaveBudget()
                            }}
                        >
                            <Col sm="12">
                                <Row className="justify-content-center align-items-center">
                                    <Form.Label
                                        htmlFor="blockCpc"
                                        className="mb-0"
                                        style={{
                                            width: 'max-content'
                                        }}
                                    >
                                        $
                                    </Form.Label>
                                    <Form.Control
                                        type="number"
                                        id="blockBudget"
                                        defaultValue={Number(campaign?.ppc_monthly_budget?.replace(',', '')) || publisher?.default_budget}
                                        style={{ width: '200px' }}
                                        onChange={e => onChangeMonthlyBudget(e)}
                                    />
                                    <Button
                                        variant="primary"
                                        style={{
                                            width: 'max-content',
                                            marginLeft: '10px'
                                        }}
                                        type="submit"
                                    >
                                        {multilang.saveBudget}
                                    </Button>
                                </Row>
                            </Col>
                            <Col sm="12">
                                <Row className="justify-content-end">
                                    <Col xl="12">
                                        <span className="d-block text-muted fs-11 ff-secondary lh-4 mt-4 text-center">
                                            {multilang.spent} <b>${campaign?.ppc_monthly_spend}</b>
                                        </span>
                                    </Col>
                                    <span className="d-block text-muted fs-11 ff-secondary lh-4 text-center">
                                        {multilang.nextBillingDay}{' '}
                                        <b>
                                            {campaign?.ppc_invoice_day}. {getShortMonthName(new Date())}
                                        </b>{' '}
                                        {multilang.daysLeft(days_diff)}
                                    </span>
                                </Row>
                            </Col>
                        </Form>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}
